import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";
import { CANDIDATE_DECLARATION } from "constants/actionTypes";
import { serializeCandidateDeclaration } from "lib/serializers/candidateDeclaration";
import queryString from "query-string";

interface UrlCreatorProps {
  id?: string;
  changesSince?: number;
  livestockSaleId?: number;
}

function urlCreator(props: UrlCreatorProps) {
  const { id, changesSince, livestockSaleId } = props;
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/candidate-declarations/", id, null),
    query: {
      changesSince,
      livestock_sale_id: livestockSaleId,
    },
  });
}

export const CandidateDeclarationAction = offlineActionCreator(
  CANDIDATE_DECLARATION,
  serializeCandidateDeclaration,
  urlCreator,
  true,
);
